<template>
  <div id="GameList">
    <div class="midLine"></div>
    <div class="lottoTitle">
      <h2>LOTTO GAME</h2>
    </div>
    <div class="container">
      <div class="card">
        <div class="cardImg">
          <img src="@/assets/img/PG5-1-498x299.png" alt="" />
        </div>
        <div class="cardContent">
          <div class="cardText">{{ $t("PG3CT1") }}</div>
          <div class="cardTitle">{{ $t("PG3CH1") }}</div>
          <router-link to="/Introduction/5" class="cardBtn">{{
            $t("MCBtn")
          }}</router-link>
        </div>
      </div>
      <div class="card">
        <div class="cardImg">
          <img src="@/assets/img/PG6-1-498x299.png" alt="" />
        </div>
        <div class="cardContent">
          <div class="cardText">{{ $t("PG3CT2") }}</div>
          <div class="cardTitle">{{ $t("PG3CH2") }}</div>
          <router-link to="/Introduction/6" class="cardBtn">{{
            $t("MCBtn")
          }}</router-link>
        </div>
      </div>
      <div class="card">
        <div class="cardImg">
          <img src="@/assets/img/PG7-1-498x299.png" alt="" />
        </div>
        <div class="cardContent">
          <div class="cardText">{{ $t("PG3CT3") }}</div>
          <div class="cardTitle">{{ $t("PG3CH3") }}</div>
          <router-link to="/Introduction/7" class="cardBtn">{{
            $t("MCBtn")
          }}</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
#GameList {
  .midLine {
    height: 16px;
    background-color: #fabf00;
    margin-bottom: 32px;
  }
  .lottoTitle {
    text-align: center;
    padding: 8px 0 16px;
    h2 {
      padding: 4px 32px;
      display: inline-block;
      color: #fabf00;
      border-right: 1px solid black;
      border-left: 1px solid black;
    }
  }
  .container {
    display: flex;
    .card {
      position: relative;
      margin: 16px;
      height: 405px;
      border: 1px solid black;
      flex: 1;
      color: #fabf00;
      text-align: center;
      .cardContent {
        .cardText {
          font-size: 18px;
          padding: 8px;
        }
        .cardTitle {
          padding: 8px;
          font-size: 24px;
        }
        .cardBtn {
          bottom: 30px;
          left: 50%;
          transform: translate(-50%, 0);
          position: absolute;
          font-size: 20px;

          background-color: #675d39;
          color: #fff8f8;
          padding: 8px 16px;
        }
      }
    }
  }
}
</style>
